import React from "react";
import CheckBox from "@components/checkBox";
import { AnchorLink } from "@src/components/anchorLink";
import { useSetDefaultValue } from "@hooks";
import PropTypes from "prop-types";
import environmentSettings from "@src/constants/environmentSettings";
import ConsentHeading from "./consentHeading.styles";

export default function PrivacyConsentCheckbox({ ...props }) {
  const {
    privacy,
    companyName,
    privacyConsentAndElectronicAuthorisation,
    creditGuide,
  } = environmentSettings;

  const { setFieldValue, name, loanReason, ...checkboxProps } = props;
  useSetDefaultValue(name, false);

  return (
    <div style={{ paddingTop: "10px" }}>
      <ConsentHeading><strong>Required Consents</strong></ConsentHeading>
      <label>
        <CheckBox {...checkboxProps} name={name}>
          You confirm that you:
          <br />
          <ul>
            <li>
              Have read, understood and agree to the{" "}
              <AnchorLink href={privacy}>Privacy Policy</AnchorLink> and the{" "}
              <AnchorLink href={privacyConsentAndElectronicAuthorisation}>
                Privacy Consent and Electronic Authorisation
              </AnchorLink>
              {"."}
            </li>
            <li>
              Consent to the collection, use, holding, and disclosure of your{" "}
              <strong>personal and credit-related information.</strong>
            </li>
            <li>
              Consent to receiving{" "}
              <strong>
                all communications, notices, legal documents and contracts
                electronically
              </strong>
              , using the information you provide in this application.
            </li>
            <li>
              Authorise {companyName} to exchange{" "}
              <strong>
                your personal and credit information with credit reporting
                bodies
              </strong>{" "}
              for the purposes of assessing your application and verifying your
              identity.
            </li>
            <li>
              Understand that even{" "}
              <strong>if you do not enter into a credit contract</strong> with{" "}
              {companyName},{" "}
              <strong>
                this may affect whether other lenders decide to offer you credit
              </strong>{" "}
              and the terms on which credit is offered.
            </li>
            <li>
              Consent to {companyName} using a{" "}
              <strong>
                third-party service provider to access your nominated bank
                accounts
              </strong>{" "}
              to obtain bank statements to assess this application and on an
              ongoing basis to confirm your continuing eligibility for credit
              products and withdrawals.
            </li>
            <li>
              Acknowledge that you have <strong>read and accessed</strong> the{" "}
              <AnchorLink href={creditGuide}>Credit Guide</AnchorLink>.
            </li>
          </ul>
        </CheckBox>
      </label>
    </div>
  );
}

PrivacyConsentCheckbox.propTypes = {
  setFieldValue: PropTypes.func,
  name: PropTypes.string,
  loanReason: PropTypes.string,
};
